import { usePublisher, insertDirective$ } from '@mdxeditor/editor'
import IconButton from '@mui/material/IconButton'
import AttachFileIcon from '@mui/icons-material/AttachFile'
import Tooltip from '@mui/material/Tooltip'
import useStore from 'reusable/mobx-store-utils'
import GapFilePluginStore from './GapFilePluginStore'
import { observer } from "mobx-react-lite"
import GapDialog from 'reusable/gap-dialog/GapDialog'
import FileUploadWithProgress from 'reusable/mui/file-uploads/FileUploadWithProgress'
import { useOrgGuardStore } from 'features/main/main-router/org-guard/OrgGuardStore'
import { useMarkdownStore } from 'reusable/markdown/MarkdownStore'

export default observer(function GapFilePlugin() {
   const insertDirective = usePublisher(insertDirective$)
   const markdownStore = useMarkdownStore()
   const orgGuardStore = useOrgGuardStore()

   const gapFilePluginStore = useStore(sp => new GapFilePluginStore(sp), {
      insertDirective,
      orgId: orgGuardStore.userOrg.orgId,
      markdownStore
   })

   return <>
      <Tooltip title="Attach file">
         <IconButton size="small" onClick={gapFilePluginStore.modalState.open}>
            <AttachFileIcon fontSize="small" />
         </IconButton>
      </Tooltip>

      <GapDialog modalState={gapFilePluginStore.modalState} size="small" title="Upload file">
         <FileUploadWithProgress
            files={gapFilePluginStore.file ? [gapFilePluginStore.file] : []}
            getPresignedUrl={gapFilePluginStore.getPresignedUrl}
            onFilesValidated={gapFilePluginStore.onFilesValidated}
            subtext="Upload a file to attach to the document"
            maxFiles={1}
            appendUlids
         />
      </GapDialog>
   </>
})
